import React, { FC, useState } from 'react'

import { ClickAwayListener, Tooltip } from '@mui/material'

import infoIcon from '../../assets/icons/iconInfo.svg'

export const InfoButton: FC<{ explanation: string | React.ReactNode }> = ({ explanation }) => {
  const [showExplanation, setShowExplanation] = useState<boolean>(false)

  const handleToggle = () => setShowExplanation((prevState) => !prevState)
  const closeTooltip = () => {
    setShowExplanation(false)
  }

  return (
    <ClickAwayListener onClickAway={closeTooltip} disableReactTree>
      <Tooltip title={explanation} open={showExplanation} arrow placement="top">
        <img src={infoIcon} alt="Info" onClick={handleToggle} />
      </Tooltip>
    </ClickAwayListener>
  )
}
